<section
  class="eventq-action-loader"
  [class.eventq-action-loader--pulsing]="pulsing()"
  [class.eventq-action-loader--fill-panel]="fill() === 'panel'"
>
  <img
    class="eventq-action-loader__emblem"
    [src]="emblemSrc() | prefixUrl"
    [style.animation-delay]="pulsing() ? pulseDelay : null"
    alt=""
    width="300"
    height="301"
  />
  <p class="eventq-action-loader__message">{{ message() }}</p>
</section>
